import { isElectronRuntime } from "@/lib/electron";

/**
 * Windows/Electron: Browser-`alert`/`confirm` hinterlassen oft kaputten Tastaturfokus
 * (Eingaben reagieren erst nach DevTools oder Alt-Tab). Native Dialoge + Fokus-Recovery vermeiden das.
 */
export function patchElectronNativeDialogs(): void {
  if (!isElectronRuntime() || !window.ehDialog) return;
  if ((window as Window & { __ehNativeDialogsPatched?: boolean }).__ehNativeDialogsPatched) {
    return;
  }

  const { alertSync, confirmSync } = window.ehDialog;
  const nativeAlert = window.alert.bind(window);
  const nativeConfirm = window.confirm.bind(window);

  window.alert = (message?: string) => {
    try {
      alertSync(String(message ?? ""));
    } catch {
      nativeAlert(message);
    }
  };

  window.confirm = (message?: string) => {
    try {
      return confirmSync(String(message ?? ""));
    } catch {
      return nativeConfirm(message);
    }
  };

  (window as Window & { __ehNativeDialogsPatched?: boolean }).__ehNativeDialogsPatched = true;
}
